import { combineReducers } from 'redux';
import { reducer as twoFaOnLoginReducer } from './check-two-fa-on-login/store/redux-slice';
export var twoFa = combineReducers({
    twoFaOnLogin: twoFaOnLoginReducer,
});
